import styled from 'styled-components';

import { SuiDropdown } from '@splashthat/sui';

import { baseSpacer } from 'common/styles/variables';

export const SelectNodeDropdown = styled(SuiDropdown)`
    margin-bottom: ${baseSpacer};
`;
